import {
  IParticleShape,
  ParticleShapeData,
} from "./VolumetricParticles.interface";

export class OrbParticles implements IParticleShape {
  generate(count: number, size: number): ParticleShapeData {
    const positions = new Float32Array(count * 3);
    const types = new Float32Array(count);
    const radius = size * 0.7;

    for (let i = 0; i < count; i++) {
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.acos(2 * Math.random() - 1);

      // Determine if particle is inside (Gold) or surface (Blue)
      // 30% inside, 70% surface
      const isInside = Math.random() < 0.3;
      types[i] = isInside ? 1.0 : 0.0;

      let r;
      if (isInside) {
        // Inside: Uniform distribution
        r = radius * Math.cbrt(Math.random());
      } else {
        // Surface: Fixed radius with slight variation for thickness
        r = radius * (0.98 + Math.random() * 0.04);
      }

      positions[i * 3] = r * Math.sin(phi) * Math.cos(theta);
      positions[i * 3 + 1] = r * Math.sin(phi) * Math.sin(theta);
      positions[i * 3 + 2] = r * Math.cos(phi);
    }
    return { positions, extraAttributes: { types } };
  }
}
